import React, { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Loader2, ScanLine } from "lucide-react";

// ─── Scan du permis de conduire (IA) ───
export function ScanLicenseButton({ onExtract, compact = false }) {
  const inputRef = React.useRef(null);
  const [scanning, setScanning] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setScanning(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/vendor/clients/scan-license", fd, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 60000,
      });
      onExtract(data.data);
      toast.success("Permis analysé — informations pré-remplies");
    } catch (err) {
      toast.error(err.response?.data?.detail || "L'analyse du permis a échoué");
    }
    setScanning(false);
  };

  return (
    <div className="rounded-xl border border-violet-100 bg-violet-50/50 p-3">
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={handleFile} data-testid="scan-license-input" />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={scanning}
        className="w-full h-10 inline-flex items-center justify-center gap-2 rounded-lg bg-violet-600 text-white text-xs font-bold hover:bg-violet-500 transition-colors disabled:opacity-60"
        data-testid="scan-license-btn"
      >
        {scanning ? <Loader2 className="h-4 w-4 animate-spin" /> : <ScanLine className="h-4 w-4" />}
        {scanning ? "Analyse du permis en cours…" : "Scanner le permis de conduire (IA)"}
      </button>
      <div className="mt-1.5 text-[10px] text-slate-500 text-center">Photographiez le permis — l'IA pré-remplit la fiche client.</div>
    </div>
  );
}

export default ScanLicenseButton;
